import React, { useEffect, useMemo } from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
import { queryParams } from "src/helpers/UrlHelpers";
import { fetchRates } from "src/actions/callrecorder/ratesActions";
import { fetchProviders } from "src/actions/callrecorder/providersActions";
import { selectProviderIds, selectProviderEntities } from "src/store/callrecorder/providersSlice";
import callrecorderUrls from "src/configs/callrecorder/callrecorderUrls";

import PageLayout from '../_partials/PageLayout';
import ListTable from "./_partials/_ListTable";
import PageHeader from "src/componets/PageHeader";
import Wrapper from "src/componets/Wrapper";
import Filter from "src/componets/Filter";

const LIMIT = 42;

const Rates = () => {
  const dispatch = useAppDispatch();
  const [searchParams] = useSearchParams();
  const currentPage = queryParams.getInt(searchParams, 'page') || 1;
  const { pathname } = useLocation();

  const providerIds = useAppSelector(selectProviderIds);
  const providerEntities = useAppSelector(selectProviderEntities);

  const activeNavId = useMemo(() => {
    const providerId = searchParams.get('provider_id');
    return providerId ? parseInt(providerId, 10) : undefined;
  }, [searchParams]);

  const navItems = useMemo(() => {
    const items: {[index: number]: any} = {};
    providerIds.forEach((id, _index) => {
      const provider = providerEntities[id];
      if (provider) {
        items[id as number] = {
          id,
          name: provider.name,
          url: callrecorderUrls.ratesPath({ order_by: 'id', provider_id: String(id) })
        };
      }
    });
    return items;
  }, [providerIds, providerEntities]);

  useEffect(() => {
    dispatch(fetchProviders({}));
  }, [dispatch]);

  useEffect(() => {
    const params: any = queryParams.requestParams(
      searchParams,
      {
        limit:  LIMIT,
        offset: (currentPage - 1) * LIMIT
      },
      ['term', 'search_by', 'order_by', 'order', 'date_from', 'date_to', 'provider_id']
    );

    dispatch(fetchRates(params));
  }, [searchParams, pathname, currentPage, dispatch]);

  return (
    <PageLayout className='v-rates'>
      <PageHeader
        title='Rates'
        navs={navItems}
        activeId={activeNavId}
        parent={{
          name: 'All',
          url: callrecorderUrls.ratesPath({ order_by: 'id' })
        }}
      />

      <div className='v-container'>
        <Wrapper type='type-1' border className='v-mb-10'>
          <Filter dateRange />
        </Wrapper>

        <ListTable limit={LIMIT} />
      </div>
    </PageLayout>
  );
}

export default Rates;
